<div class="container">
  <div
    [ngClass]="decimalWeight ? 'holder border-active' : 'holder border-disable'"
    style="right: 60px"
  >
    <input
      type="tel"
      [(ngModel)]="decimalWeight"
      maxlength="3"
      (input)="checkActivatingButton(0)"
      (focus)="decimalWeight = ''"
      attr.id="input{{ 0 }}"
    />
  </div>
  <div class="dot">.</div>
  <div
    [ngClass]="
      fractionalWeight ? 'holder border-active' : 'holder border-disable'
    "
    style="right: 0px"
  >
    <input
      type="tel"
      [(ngModel)]="fractionalWeight"
      maxlength="1"
      (input)="checkActivatingButton(1)"
      (focus)="fractionalWeight = ''"
      (keyup)="keytab($event, 1)"
      attr.id="input{{ 1 }}"
    />
  </div>
</div>
<div *ngIf="hasError" class="error-title">وزن وارد شده اشتباه است</div>
<div class="input-title">کیلوگرم</div>
